import { HttpService } from "./https.service";
import { BASE_URL } from "../../config/config";

const http = new HttpService();

export class ZapFlowService {
    static async getZapFlowAnalytics(params: {
        start_date?: string;
        end_date?: string;
        influencer_id?: string;
    }): Promise<any> {
        try {
            const qs = new URLSearchParams(
                Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== ''))
            ).toString();
            const path = BASE_URL + `/zap-flow/admin/analytics${qs ? '?' + qs : ''}`;
            return await http.getRequest(path, null);
        } catch (error) {
            throw new Error(`getZapFlowAnalytics: ${error}`);
        }
    }

    static async getUserAutomations(params: {
        influencer_id: string | number;
        start_date?: string;
        end_date?: string;
    }): Promise<any> {
        try {
            const qs = new URLSearchParams(
                Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== '').map(([k, v]) => [k, String(v)]))
            ).toString();
            const path = BASE_URL + `/zap-flow/admin/user-automations${qs ? '?' + qs : ''}`;
            return await http.getRequest(path, null);
        } catch (error) {
            throw new Error(`getUserAutomations: ${error}`);
        }
    }

    // Storefront + Link-in-Bio drill-down for one influencer (admin dashboard).
    static async getPresenceDetail(params: {
        influencer_id: string | number;
        start_date?: string;
        end_date?: string;
    }): Promise<any> {
        try {
            const qs = new URLSearchParams(
                Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== '').map(([k, v]) => [k, String(v)]))
            ).toString();
            const path = BASE_URL + `/zap-flow/admin/presence-detail${qs ? '?' + qs : ''}`;
            return await http.getRequest(path, null);
        } catch (error) {
            throw new Error(`getPresenceDetail: ${error}`);
        }
    }

    static async searchInfluencers(q: string): Promise<any> {
        try {
            const path = BASE_URL + `/zap-flow/admin/search-influencers?q=${encodeURIComponent(q)}`;
            return await http.getRequest(path, null);
        } catch (error) {
            throw new Error(`searchInfluencers: ${error}`);
        }
    }

    static async getAutomationTracking(params: {
        ig_automation_id: string | number;
        start_date?: string;
        end_date?: string;
    }): Promise<any> {
        try {
            const qs = new URLSearchParams(
                Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== '').map(([k, v]) => [k, String(v)]))
            ).toString();
            const path = BASE_URL + `/zap-flow/admin/automation-tracking${qs ? '?' + qs : ''}`;
            return await http.getRequest(path, null);
        } catch (error) {
            throw new Error(`getAutomationTracking: ${error}`);
        }
    }
}
